module.exports = __webpack_public_path__ + "img/pregunta-10.6b12ec37.png";